<template>
        <!-- En-tête -->
        <EventHeader
            :category="eventData.category.name"
            :title="eventData.title"
            :published-date="eventData.created_at"
            :author="organizer"
            @share="$emit('share')"
        />




</template>

<script setup>


import EventHeader from "@/vue/Public/event/detail/EventHeader.vue";

const props = defineProps({
    eventData: {
        type: Object,
        required: true
    },
    organizer: {
        type: String,
        default: ''

    }
})

defineEmits(['share'])
</script>
